import { UserRoleEntry, UserRoles } from '../types/user-roles';
import { userRoles } from '../constants/user-roles';

export const getUserRoleEntryByRoleId = (roleId: number): UserRoleEntry<UserRoles> | undefined => {
  for (const userRole of Object.values(userRoles)) {
    if (userRole.roleId === roleId) {
      return userRole;
    }
  }
  return undefined;
};
